module.exports = __webpack_public_path__ + "assets/img/Discover-Massage-Australia-eBook-w720.933ac4fc.webp";